module.exports = __webpack_public_path__ + "static/media/AK.a7751a90.png";